import Chip from '@mui/material/Chip';
import { observer } from 'mobx-react-lite';
import {
  Button,
  Page,
  SavingIndicator,
  TextField,
  Widget,
} from '../../../components';
import { useAccount } from '../../../store';
import classes from './LabelsPage.module.scss';

export default observer(function LabelsPage() {
  const account = useAccount();
  const { labels } = account.configurations;

  return (
    <Page navigation={{ title: 'Labels for Pulse Keys ', icon: 'tag' }}>
      <Widget
        className={classes.toolbar}
        surface="gray"
        sx={{ width: 320 }}
        title="Create new label"
      >
        <TextField
          label="Label name"
          onChange={(e) => labels.setNewLabel(e.target.value)}
          sx={{ mb: 2, mt: 0, width: 304 }}
          value={labels.newLabel}
        />
        <Button
          disabled={!labels.isNewLabelValid}
          icon="plus"
          onClick={labels.addNewLabel}
          size="small"
          type="primary"
        >
          Create label
        </Button>
      </Widget>

      <div className={classes.list}>
        {labels.items.map((label) => (
          <Chip
            className={classes.item}
            key={label}
            label={label}
            onDelete={
              labels.canRemoveLabel(label)
                ? () => labels.deleteLabel(label)
                : undefined
            }
            sx={{ marginTop: 1 }}
          />
        ))}
      </div>

      <SavingIndicator indicator={labels.indicator} sx={{ mt: 2 }} />
    </Page>
  );
});
